import { render, staticRenderFns } from "./152.vue?vue&type=template&id=52f616eb&scoped=true&"
var script = {}
import style0 from "./152.vue?vue&type=style&index=0&id=52f616eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f616eb",
  null
  
)

export default component.exports